/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import {useTypedSelector} from "helpers/reducers";
import Dates from "utils/Dates";
import clsx from "clsx";
import BookingLoginReservationDetailInputBlank
    from "pages/Front/Booking/BookingLogin/components/BookingLoginReservationDetail/components/BookingLoginReservationDetailInputBlank";
import {padMinutes} from "utils/utility";
import BookingCardTitle from "pages/Front/Booking/components/BookingCardTitle";
import BookingCard from "pages/Front/Booking/components/BookingCard";

interface SellerHeaderProps {
    step: number;
    description?: string;
}

const SellerHeader = (props: SellerHeaderProps) => {
    const {t} = useTranslation();
    const packagesCart = useTypedSelector(state => state.bookingState.bookingProcess.packageCart);
    const company = useTypedSelector(state => state.bookingState.bookingProcess.customer);
    return (
        <div className={"SellerHeader"}>
            <h1 className={"text-gray-900 text-2xl font-bold space-x-2 leading-none"}>
                {t("New reservation")}
            </h1>

            <div className={"inline-flex items-center w-full gap-x-1 text-lg mb-0.5 text-gray-600"}>
                <span className={"font-medium"}>Step:</span> <span className={"font-bold"}>{props.step}/6</span>
            </div>

            {props.description && (
                <p className={"inline-flex items-center font-semibold text-gray-600 mb-4"}>
                    <span>{props.description}</span>
                </p>
            )}

            <BookingCard className={clsx("ReservationsForDate !px-0 !py-0 mb-6")}>
                <BookingCardTitle className={"px-3 py-2.5 xl:px-3 xl:py-3 border-b"} title={t("Reservation basic information")} />
                <div className={"grid sm:grid-cols-2 md:grid-cols-4 gap-3 px-3 py-3"}>
                    <BookingLoginReservationDetailInputBlank className={"col-span-1"} label={t("Check-in Code")} name={"code"} value={packagesCart?.reservation?.guid ?? "---"} />
                    <BookingLoginReservationDetailInputBlank
                        className={"col-span-1"}
                        label={t("Reservation at")}
                        name={"reservation_at"}
                        value={packagesCart?.date ? Dates.ymd(packagesCart?.date, "DD.MM.YYYY") : "---"}
                    />
                    <BookingLoginReservationDetailInputBlank
                        className={"col-span-1"}
                        label={t("Start")}
                        name={"hour"}
                        value={packagesCart?.hour ? padMinutes(packagesCart.hour) + ":" + padMinutes(packagesCart.minute) : "---"}
                    />
                    <BookingLoginReservationDetailInputBlank className={"col-span-1"} label={t("Company name")} name={"name"} value={company?.name ?? "---"} />
                    <BookingLoginReservationDetailInputBlank className={"col-span-1"} label={t("First name")} name={"first_name"} value={company?.first_name ?? "---"} />
                    <BookingLoginReservationDetailInputBlank className={"col-span-1"} label={t("Last name")} name={"last_name"} value={company?.last_name ?? "---"} />
                    {company?.email && (<BookingLoginReservationDetailInputBlank className={"col-span-1"} label={t("Email")} name={"email"} value={company?.email ?? "---"} />)}
                    {company?.phone && (<BookingLoginReservationDetailInputBlank className={"col-span-1"} label={t("Phone")} name={"phone"} value={company?.phone ?? "---"} />)}
                </div>
            </BookingCard>
        </div>
    );
};

export default SellerHeader;
